<div class="w-30rem">
  <ui-card>
    <div class="w-full flex flex-column gap-3">
      <div class="flex flex-column align-items-center justify-content-center gap-3">
        <img src="assets/Novatellus.svg" alt="Novatellus" class="w-12rem max-w-full h-auto" />

        <ng-container *ngIf="state() === 'form'">
          <span class="text-2xl font-bold">Imposta una nuova password</span>
          <span class="text-sm text-center">
            Scegli una password di almeno {{ passwordMinLength }} caratteri. Verrà usata anche
            per accedere con il tuo account Novatellus.
          </span>
        </ng-container>

        <ng-container *ngIf="state() === 'done'">
          <span class="text-2xl font-bold">Password aggiornata</span>
          <span class="text-sm text-center">{{ message() }}</span>
          <span class="text-sm text-center">Accedi con la nuova password.</span>
        </ng-container>

        <ng-container *ngIf="state() === 'missing-token'">
          <span class="text-2xl font-bold">Link incompleto</span>
          <span class="text-sm text-center">
            Manca il codice di ripristino. Apri il link direttamente dall'email che ti abbiamo
            inviato, oppure richiedine uno nuovo.
          </span>
        </ng-container>
      </div>

      <form
        *ngIf="state() === 'form'"
        #resetForm="ngForm"
        (ngSubmit)="onSubmit(resetForm)"
        class="w-full flex flex-column gap-3"
      >
        <span class="w-full flex flex-column gap-2">
          <label for="resetPassword">Nuova password*</label>
          <p-password
            id="resetPassword"
            name="password"
            [(ngModel)]="model.password"
            required
            [minlength]="passwordMinLength"
            [maxlength]="passwordMaxLength"
            [feedback]="false"
            [toggleMask]="true"
            autocomplete="new-password"
            styleClass="w-full"
            inputStyleClass="w-full"
            [attr.aria-describedby]="
              passwordControl.invalid && passwordControl.touched ? 'resetPassword-error' : null
            "
            #passwordControl="ngModel"
          ></p-password>
          <span
            id="resetPassword-error"
            class="text-sm text-color-secondary"
            *ngIf="passwordControl.invalid && passwordControl.touched"
          >
            La password deve contenere da {{ passwordMinLength }} a {{ passwordMaxLength }} caratteri.
          </span>
        </span>

        <span class="w-full flex flex-column gap-2">
          <label for="resetConfirmPassword">Conferma nuova password*</label>
          <p-password
            id="resetConfirmPassword"
            name="confirmPassword"
            [(ngModel)]="model.confirmPassword"
            required
            [feedback]="false"
            [toggleMask]="true"
            autocomplete="new-password"
            styleClass="w-full"
            inputStyleClass="w-full"
            [attr.aria-describedby]="passwordsDoNotMatch ? 'resetConfirmPassword-error' : null"
          ></p-password>
          <span
            id="resetConfirmPassword-error"
            class="text-sm text-color-secondary"
            role="alert"
            *ngIf="passwordsDoNotMatch"
          >
            Le password non coincidono.
          </span>
        </span>

        <div *ngIf="submitError" class="text-sm text-center" role="alert">{{ submitError }}</div>

        <p-button
          type="submit"
          label="Salva la nuova password"
          styleClass="w-full"
          [disabled]="(resetForm.invalid ?? true) || passwordsDoNotMatch"
          [loading]="isSubmitting"
        ></p-button>
      </form>

      <!-- Password aggiornata: stesso accesso Keycloak della topbar. -->
      <p-button
        *ngIf="state() === 'done'"
        type="button"
        label="Accedi"
        icon="pi pi-sign-in"
        styleClass="w-full reset-password__login"
        (onClick)="onKeycloakLogin()"
      ></p-button>

      <span
        class="text-center text-sm"
        *ngIf="state() === 'missing-token' || canRequestNewLink"
      >
        Richiedi un nuovo link
        <p-button
          label="Recupera password"
          [text]="true"
          size="small"
          severity="secondary"
          styleClass="underline p-0"
          [routerLink]="['/', AppRoutes.AUTH, AppRoutes.AUTH_FORGOT_PASSWORD]"
        />
      </span>

      <span class="text-center text-sm">
        Torna alla vetrina dei piani
        <p-button
          label="Piani"
          [text]="true"
          size="small"
          severity="secondary"
          styleClass="underline p-0"
          (onClick)="goToPlans()"
        />
      </span>
    </div>
  </ui-card>
</div>
